import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex justify-center">
          <div className="text-center max-w-4xl">
            <figure className="mb-8">
              <img
                src="assets/images/404_img.webp"
                alt="404 Not Found"
                className="mx-auto max-w-full h-auto"
              />
            </figure>
            <p className="text-3xl font-bold mb-4 opacity-[0.7] leading-tight">
              WHOPPS !!! <br />
              <span className="font-normal">
                We could not find the page you are looking for.
                <br />
                Please check to make sure you have typed the URL correctly.
              </span>
            </p>
            <Link
              to="/"
              className="inline-block bg-yellow-500 text-white text-lg px-6 py-3 rounded-[100px] hover:bg-yellow-700 transition"
            >
              Back to Home Page
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFoundSection;
